import slice from './menuSlice';

export * from './menuSlice';
export default slice;
